import React, { useContext, useEffect, useRef, useState } from "react";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toolbar } from "primereact/toolbar";
import { InputText } from "primereact/inputtext";
import TextInput from "../../componets/TextInput";
import { Dialog } from "primereact/dialog";
import { TabPanel, TabView } from "primereact/tabview";
import { OrderList } from "primereact/orderlist";
import { MultiSelect } from "primereact/multiselect";
import { Toast } from "primereact/toast";
import { moduleService } from "../../services/ModuleService";
import { userGroupsService } from "../../services/UserGroupsService";
import { lookupsService } from "../../services/LookupsService";
import { EditUserGroup } from "./EditUserGroup";
import { AppDB } from "../../App";

import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { permissionLookUp } from "./../../constants";

export const UserGroups = () => {
	var { permission } = useContext(AppDB);
	const toast = useRef(null);
	let [data, setData] = useState([]);
	const [showAddUserGroupForm, setShowAddUserGroupForm] = useState(false);
	const [showGroup, setShowGroup] = useState(false);
	const [loading, setLoading] = useState(false);

	
	const [selectedGroup, setSelectedGroup] = useState(null);
	var [modules, setModules] = useState([]);
	const [selectedModule, setselectedModule] = useState([]);
	var [form, setForm] = useState({
		description: "",
		name: "",
		modules: []
	});

	useEffect(() => {
		moduleService
			.getAll()
			.then((data) => {
				if(data.success)
				{
					setModules(data.data);
				}
				else 
				{
					toast.current.show({
						severity: "error",
						summary: "Error Message",
						detail: "Could not load moduls",
						life: 3000
					});
				}
			})
			.catch((e) => {
				console.error(e.message);
			});

		setLoading(true);

		GetSystemGrops();
		// userGroupsService
		// 	.getAll()
		// 	.then((data) => {
		// 		setLoading(false);
		// 		setData(data);
		// 	})
		// 	.catch((e) => {
		// 		setLoading(false);
		// 		console.error(e.message);
		// 	});
	}, []);

	function GetSystemGrops()
	{
		userGroupsService
			.getAll()
			.then((data) => {
				setLoading(false);
				setData(data);
			})
			.catch((e) => {
				setLoading(false);
				console.error(e.message);
				toast.current.show({
					severity: "error",
					summary: "Error Message",
					detail: "Could not get system groups.",
					life: 3000
				});
			});
	}

	var [gorupSearch, setGroupSearch] = useState("")
	function SearchUserGroup()
	{
		if(gorupSearch)
		{
			setLoading(true);
			userGroupsService
			.getAllByGroupName(gorupSearch)
			.then((data) => {
				setLoading(false);
				if(data.success)
				{
					setData(data.data);
				}
				else 
				{
					toast.current.show({
						severity: "error",
						summary: "Error Message",
						detail: "Could not get system groups.",
						life: 3000
					});
				}
			})
			.catch((e) => {
				setLoading(false);
				console.error(e.message);
				toast.current.show({
					severity: "error",
					summary: "Error Message",
					detail: "Could not get system groups.",
					life: 3000
				});
			});
		}
		else
		{
			GetSystemGrops();
		}

	}
	const header = (
		<div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
			<h5 className="m-0">User Groups</h5>
		</div>
	);

	function getGroups() {
		setShowGroup(false);
		setSelectedGroup(null);
		// userGroupsService.getAll().then((data) => {
		// 	setData(data);
		// });
	}

	var submittedForm = false;
	function SubmitForm() {
		var modules = [];
		if (selectedModule != null && Array.isArray(selectedModule) == true) selectedModule.map((module) => modules.push({moduleID: module.moduleID}));

		var newForm = {};

		Object.keys(form).map((key) => {
			newForm[key] = form[key];
		});

		newForm["modules"] = modules;

		var error = false;
		Object.keys(newForm).map((key) => {
			var value = newForm[key];
			if (value?.length === 0) {
				error = true;
			}
		});

		if (error == true) {
			toast.current.show({
				severity: "error",
				summary: "Error Message",
				detail: "please fill the required fields",
				life: 3000
			});
			return false;
		}

		var requestBody = {
			Description: newForm.description,
			Name: newForm.name,
			modules: newForm.modules
		};

		userGroupsService
			.create(requestBody)
			.then((res) => {
				setTimeout(() => {
					window.location.reload();
					submittedForm = true;
				}, 2000);
				return toast.current.show({
					severity: "success",
					summary: "Success Message",
					detail: "User group was added successfully",
					life: 2000
				});
			})
			.catch((e) => {
				submittedForm = false;
				return toast.current.show({
					severity: "error",
					summary: "Error Message",
					detail: "Ooops, The is a technical problem,Please Try Again",
					life: 3000
				});
			});
	}

	function selectedGroupData1() {
		return [
			{
				col1: "Name",
				col21: selectedGroup?.name,
				col3: "Description",
				col4: selectedGroup?.description
			},
			{
				col1: "Captured By",
				col2: selectedGroup?.createdBy,
				col3: "Captured Date",
				col4: new Date(selectedGroup?.createdDate).toLocaleString()
			}
		];
	}

	function selectedGroupData2() {
		return [
			{
				col1: "Updated By",
				col2: selectedGroup?.updatedBy,
				col3: "Updated Date",
				col4: new Date(selectedGroup?.updatedDate).toLocaleString()
			}
		];
	}

	const onSaveGroup = () => {
		setShowGroup(false);
		userGroupsService
			.getAll()
			.then((data) => {
				setData(data);
			})
			.catch((e) => {
				console.error(e.message);
			});
	};

	const confirmDeleteDelimitation = (group) => {
		confirmDialog({
			message: "Are you sure you want to delete this item?",
			header: "Delete System Group",
			icon: "pi pi-exclamation-triangle",
			accept: () => DeleteSystemGroup(group),
			reject: () => {}
		});
		
	};
	function DeleteSystemGroup(group)
	{
		userGroupsService
			.deleteSystemGroup(group.groupID)
			.then((res) => {
				setTimeout(() => {
					window.location.reload();
					submittedForm = true;
				}, 2000);
				return toast.current.show({
					severity: "success",
					summary: "Success Message",
					detail: "User group was deleted successfully",
					life: 2000
				});
			})
			.catch((e) => {
				submittedForm = false;
				return toast.current.show({
					severity: "error",
					summary: "Error Message",
					detail: "Ooops, The is a technical problem,Please Try Again",
					life: 3000
				});
			});

	}
	return (
		<div className="card  p-align-stretch vertical-container">
			<div className="">
			<ConfirmDialog />
				<Toast ref={toast} />
				<Toolbar
					className="mb-4"
					left={
						<div>
							{(permission?.actions?.includes(permissionLookUp.Create) ||
							permission?.actions?.includes(permissionLookUp.Update)) && (
								<Button
								className="p-button-success mr-2"
								icon="pi pi-plus"
								label="Add User Group"
								onClick={(e) => setShowAddUserGroupForm(true)}
								/>
							)}
						</div>
					}
					right={
						<div>
							<span className="block mt-2 md:mt-0 p-input-icon-left">
								<i className="pi pi-search" />
								<InputText placeholder="Search..."  onChange={(e) => setGroupSearch(e.target.value)}/>
								<Button className="p-button-success ml-4" label="Search" onClick={SearchUserGroup} />
							</span>
						</div>
					}
				></Toolbar>
			</div>

			{/* add users */}
			{/* <AddUserGroup
        show={showAddUserGroupForm}
        setShow={setShowAddUserGroupForm}
      /> */}
			{/* end */}

			<DataTable
				size="small"
				scrollable={true}
				value={data}
				dataKey="id"
				paginator
				rows={10}
				rowsPerPageOptions={[5, 10, 25]}
				className="datatable-responsive"
				currentPageReportTemplate="Showing {first} to {last} of {totalRecords} users"
				emptyMessage="No user groups found."
				header={header}
				responsiveLayout="scroll"
				resizableColumns
				columnResizeMode="expand"
				loading={loading}
			>
				<Column field="name" header="Name" sortable></Column>
				<Column field="description" header="Description"></Column>
				{(permission?.actions?.includes(permissionLookUp.Read)||
				permission?.actions?.includes(permissionLookUp.Update) ||
				permission?.actions?.includes(permissionLookUp.Create) )&&(
					<Column
					field="actions"
					header="Actions"
					body={(rowData) => (
						<>
							{(permission?.actions?.includes(permissionLookUp.Read)||
							permission?.actions?.includes(permissionLookUp.Update) ||
							permission?.actions?.includes(permissionLookUp.Create)
							) && (
								<Button
								style={{ textAlign: "center", width: "30px", height: "30px" }}
								icon={"pi pi-eye"}
								className="p-button-primary p-button-rounded mr-2 "
								tooltipOptions={{ position: "top" }}
								tooltip="Click to View"
								onClick={() => {
									setSelectedGroup(rowData);
									setShowGroup(true);
								}}
								/>
							)}
							{/* <Button
								style={{ textAlign: "center", width: "30px", height: "30px" }}
								icon={"pi pi-times"}
								className="p-button-primary p-button-rounded mr-2 "
								tooltipOptions={{ position: "top" }}
								tooltip="Click to De-activate"
								/> */}
							{permission?.actions?.includes(permissionLookUp.Delete) &&(
								<Button
								style={{ textAlign: "center", width: "30px", height: "30px" }}
								icon={"pi pi-trash"}
								className="p-button-danger p-button-rounded"
								tooltipOptions={{ position: "top" }}
								tooltip="Click to Delete"
								onClick={() => {
									confirmDeleteDelimitation(rowData)
								}}
								/>
							)}
						</>
					)}
					></Column>
				)}
			</DataTable>

			<Dialog
				draggable={false}
				header={
					<>
						<i className="pi pi-plus"></i>
						<span> Add User Group</span>
					</>
				}
				footer={
					<>
				<Button label="Submit" onClick={SubmitForm} className="p-button-primary" icon="pi pi-plus" type="submit" />
				<Button label="Cancel" onClick={(e) => setShowAddUserGroupForm(false)} className="p-button-danger" icon="pi pi-times-circle"/>
				</>
				}
				visible={showAddUserGroupForm}
				onHide={(e) => setShowAddUserGroupForm(false)}
				style={{ width: "45%", height: "90%" }}
			>
				<div className="grid">
					<div className="col-12">
						<TextInput label="Name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
					</div>

					<div className="col-12">
						<TextInput value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} label="Description" />
					</div>

					<div className="col-12">
						<label>Modules</label>
						<MultiSelect
							style={{ width: "100%" }}
							value={selectedModule}
							options={modules}
							onChange={(e) => setselectedModule(e.value)}
							optionLabel="name"
							placeholder="Select modules"
							filter
							className="multiselect-custom"
							display="chip"
						/>
						{/* {selectedModule != null && selectedModule?.length > 0 ? (
							<OrderList
								value={selectedModule}
								listStyle={{ height: "auto" }}
								dataKey="id"
								itemTemplate={(item) => item.descriiption}
							></OrderList>
						) : (
							""
						)} */}
					</div>
				</div>
			</Dialog>

			{selectedGroup && <EditUserGroup group={selectedGroup} visible={showGroup} onHide={getGroups} onSaveGroup={onSaveGroup} />}
		</div>
	);
};
